{
    "Accessibility": {
        "SvgTitle": {
            "agentIndicator": "Indicateur d'agent",
            "botIndicator": "Indicateur de bot",
            "chatIcon": "Icône de chat",
            "checkboxIcon": "Icône de case à cocher",
            "chevronDown": "Chevron vers le bas",
            "chevronRight": "Chevron vers la droite",
            "clockIcon": "Icône d'horloge",
            "closeIcon": "Icône de fermeture",
            "endChatIcon": "Icône de fin de discussion",
            "feedbackIcon": "Icône de retour d'information",
            "menuIcon": "Icône de menu",
            "muteIcon": "Icône de mise en sourdine",
            "newMessageIcon": "Icône de nouveau message",
            "radioIcon": "Icône de bouton radio",
            "ratingStarIcon": "Icône d'étoile de notation",
            "receiptIcon": "Icône de reçu",
            "ringIcon": "Icône Ring",
            "sendIcon": "Icône d'envoi",
            "themeIcon": "Icône de thème",
            "thumbsDownIcon": "Icône de pouce vers le bas",
            "thumbsUpIcon": "Icône de pouce vers le haut",
            "unmuteIcon": "Icône d'activation du son",
            "userIcon": "Icône d'utilisateur"
        }
    },
    "Components": {
        "Alert": {
            "ariaLabel": "Fermer",
            "endChatError": "Impossible de terminer la session, veuillez réessayer",
            "sessionEnded": "Votre session est terminée. Vous avez été redirigé vers la page d'accueil.",
            "networkError": "Un problème est survenu lors de la connexion à votre session, veuillez réessayer",
            "messageError": "Désolé, notre chat est actuellement indisponible. Veuillez consulter <a href='https://ring.com/support'>l'aide Ring</a> pour obtenir des ressources utiles ou réessayer dans quelques minutes.",
            "messageLabel": "alerte",
            "pendingTimeout": "Nous sommes désolés, notre assistant est en retard à répondre. Veuillez réessayer ou reformuler votre question."
        },
        "Body": {
            "latestMessage": "Derniers messages",
            "loadMessages": "Charger les messages",
            "newMessage": "Nouveau message",
            "title": "Comment pouvons-nous vous aider ?",
            "subtitle": "Bonjour ! Je suis l'assistant du service client Ring. Comment puis-je vous aider ?"
        },
        "Bubble": {
            "ariaLabel": "message de discussion",
            "eventsTitle": "Événements récents",
            "sourceTitle": "Liens utiles"
        },
        "Entry": {
            "reasoningAriaLabel": "Pensant",
            "reasonings": {
                "thinkingText": "Pensant"
            }
        },
        "Event": {
            "defaultJoin": "Un membre de l'équipe Ring a rejoint la discussion en direct.",
            "customerJoin": "Redirigé vers la discussion en direct.",
            "agentJoin": "a rejoint la discussion en direct.",
            "defaultLeft": "Le membre de l'équipe Ring a quitté la discussion en direct.",
            "customerLeft": "Vous avez quitté la discussion.",
            "agentLeft": "a quitté la discussion en direct.",
            "idle": "Vous êtes inactif depuis un certain temps. N'hésitez pas à nous contacter si vous avez besoin d'aide !",
            "idleContinue": "Je suis toujours là, j'ai simplement besoin d'un peu plus de temps",
            "idleEnd": "Terminer la discussion",
            "returned": "Heureux de vous revoir ! Poursuivons la conversation."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Pouce en l'air",
            "ariaLabelThumbsDown": "Pouce vers le bas",
            "header": "Cela vous a-t-il été utile ?",
            "sent": "Merci pour votre retour",
            "thumbsDown": "Désolée de ne pas avoir pu répondre de manière satisfaisante. Nous aimerions connaître votre avis sur la manière de nous améliorer.",
            "thumbsDownResponse": "Merci pour votre retour. Veuillez essayer de reformuler votre question.",
            "thumbsUp": "Nous sommes ravis d'avoir pu vous aider ! Si vous avez d'autres questions, n'hésitez pas à nous en faire part.",
            "RESPONSE_UNCLEAR": "Réponse peu claire",
            "ISSUE_UNRESOLVED": "N'a pas résolu mon problème",
            "NOT_HELPFUL": "Pas utile"
        },
        "Footer": {
            "ariaLabel": "Envoyer",
            "placeholder": "Posez une question rapide...",
            "botText": "Ce chatbot répond à vos questions à l'aide de l'IA générative. Veuillez vérifier toute information importante fournie dans ces réponses avant d'agir."
        },
        "Header": {
            "ariaLabelMenu": "Menu Plus",
            "ariaLabelMinimize": "Réduire",
            "badgeTitle": "BÊTA",
            "badgeDisabled": "Déconnecté",
            "themeLabel": "Thème",
            "muteLabel": "Silencier",
            "unmuteLabel": "Désilencier",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Terminer la discussion"
        },
        "NotificationCard": {
            "ariaLabelClose": "Fermer",
            "ariaLabelOpen": "Ouvrir",
            "notification": "Nouveau message",
            "expand": "Cliquez pour agrandir"
        },
        "WidgetIcon": {
            "ariaLabel": "Discutez pour obtenir de l'aide"
        },
        "WelcomeScreen": {
            "ariaLabel": "Réduire",
            "button": "Démarrer la discussion",
            "title": "Merci d'avoir pris contact avec Ring",
            "subtitleHtml": "En poursuivant, vous acceptez les <a href='https://ring.com/terms'>conditions d'utilisation de Ring</a>. Les informations relatives à cette discussion sont susceptibles d'être collectées et enregistrées. Pour en savoir plus, consultez <a href='https://ring.com/privacy-notice'>notre avis de confidentialité</a>.",
            "loading": "Démarrage de la discussion...",
            "error": "Impossible d'ouvrir la session, veuillez réessayer",
            "messageLabel": "texte de bienvenue"
        }
    }
}